import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import type { Dayjs } from 'dayjs';
import { FormHelperText } from '@mui/material';

import DatePickerContainer from './CustomDatePicker.style';

type PropsType = {
  label: string;
  value?: Dayjs;
  errorText?: string;
  isTouched?: boolean;
  onChange?: (value: Dayjs | null) => void;
  onClose?: () => void;
  hideHelperText?: boolean;
};

const CustomDatePicker = ({
  label = 'mm/dd/yyyy',
  value,
  errorText,
  isTouched,
  hideHelperText,
  onChange = () => null,
  onClose = () => null,
}: PropsType) => {
  const isErrorDisplay = isTouched && Boolean(errorText);
  return (
    <DatePickerContainer>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={label}
          value={value}
          onChange={onChange}
          onClose={onClose}
          slotProps={{
            textField: {
              error: isErrorDisplay,
            },
          }}
        />
      </LocalizationProvider>
      {isErrorDisplay && !hideHelperText && (
        <FormHelperText error={isErrorDisplay}>{errorText}</FormHelperText>
      )}
    </DatePickerContainer>
  );
};

export default CustomDatePicker;
